"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var use9PMRefresh = function () {
    var _a = (0, react_1.useState)(new Date()), loadedAt = _a[0], setLoadedAt = _a[1]; // default value can be anything you want
    var _b = (0, react_1.useState)(false), reloaded = _b[0], setReloaded = _b[1];
    (0, react_1.useEffect)(function () {
        var interval = setInterval(function () {
            var currentHourOfDay = new Date().getHours();
            var currentMinutes = new Date().getMinutes();
            var minuteCutOff = 0; // 0
            var hourCutOff = 21; // 9pm
            if (currentHourOfDay === hourCutOff && // check the current hour is the time to refresh
                currentMinutes === minuteCutOff && // check the correct minute
                ((minuteCutOff === 0 && loadedAt.getHours() < hourCutOff) ||
                    minuteCutOff > 0) && // check if the hour has swapped over if this is set an on the hour change
                !reloaded // check this hasn't remounted already
            ) {
                setLoadedAt(new Date());
                setReloaded(true);
            }
        }, 1000);
        return function () {
            clearInterval(interval);
        };
    }, [loadedAt, reloaded]);
    return {
        loadedAt: loadedAt,
        reloaded: reloaded,
    };
};
exports.default = use9PMRefresh;
//# sourceMappingURL=use9PMRefresh.js.map